import { gql } from "@apollo/client";

export const FETCH_ALL_CATALOGS = gql`
  query FETCH_ALL_CATALOGS {
    allCatalogs(statusIn: ["new", "old"]) {
      id
      name
      poster: posterSrc
      pdf: pdfSrc
      status
      isActive
      order
    }
  }
`;

export const CREATE_CATALOG = gql`
  mutation CREATE_CATALOG(
    $name: String!
    $status: String!
    $poster: Upload!
    $pdf: Upload!
  ) {
    createCatalog(name: $name, status: $status, poster: $poster, pdf: $pdf) {
      catalog {
        id
        name
        poster: posterSrc
        pdf: pdfSrc
        status
        isActive
        order
      }
    }
  }
`;

export const UPDATE_CATALOG = gql`
  mutation UPDATE_CATALOG(
    $id: ID!
    $name: String
    $status: String
    $isActive: Boolean
    $order: Int
    $poster: Upload
    $pdf: Upload
  ) {
    updateCatalog(
      id: $id
      name: $name
      status: $status
      isActive: $isActive
      order: $order
      poster: $poster
      pdf: $pdf
    ) {
      catalog {
        id
        name
        poster: posterSrc
        pdf: pdfSrc
        status
        isActive
        order
      }
    }
  }
`;
